import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { createQueryClient } from "./app/query-client";
import { routes } from "./app/routes";
import { bindSessionToCache } from "./app/session-sync";
import { bootstrapSession } from "./features/auth/auth-api";
import { isApplyPath, isSetPasswordPath, isSigningPath } from "./lib/sign-in-paths";
import { useAuthStore } from "./stores/auth-store";
import "./styles/index.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element in index.html");

const queryClient = createQueryClient();
const router = createBrowserRouter(routes);

// Cached data belongs to one person; clear it when they change, and keep tabs in step.
bindSessionToCache(queryClient);

// Restore the session from the refresh cookie while the first screen renders. Not on the public
// signing, set-password or admission pages: a session restored in the background must not touch
// them (the set-password page signs its person in itself).
const path = window.location.pathname;
if (isSigningPath(path) || isSetPasswordPath(path) || isApplyPath(path)) {
  useAuthStore.getState().clearSession();
} else void bootstrapSession();

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
